export function useEnvironment() {

  const env = import.meta.env
  const environmentKey = 'VITE_ENVIRONMENT'

  const isProduction = env[environmentKey] === 'prod' ||
      env[environmentKey] === 'production' ||
      env[environmentKey] === 'live'

  return {
    isProduction,
    env,
  }
}